import {Route, Routes} from 'react-router-dom'
import LavanderiaPageWrapper from '../khipu/features/lavanderia/pages/LavanderiaPageWrapper'

const LavanderiaRoutes = () => {
  return (
    <Routes>
      <Route index element={<LavanderiaPageWrapper />} />
    </Routes>
  )
}

export {LavanderiaRoutes}
